require('../../modules/es.object.get-own-property-descriptors');
var path = require('../../internals/path');

module.exports = path.Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/get-own-property-descriptors.js
// module id = 1000
// module chunks = 0